<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <span class="back" @click="$router.go(-1)"><i class="el-icon-back"></i>&nbsp;&nbsp;&nbsp;&nbsp;返回</span>
            <div class="wrap">
                <div class="content">
                    <div class="main-box" style="padding-top:20px">
                        <div class="cnt">
                            <div class="parpers_cnt">
                                <div class="info_top">
                                    <p class="ico-wrap">
                                        <img
                                            src="@/assets/images/realName/success.png"
                                            alt=""
                                        />
                                    </p>
                                    <p class="gz">
                                        您的实名认证资料已提交完成,请使用<b>{{remittanceInfo.name}}</b>的<b>{{remittanceInfo.bankName}}</b>账户 （尾号为<b>{{remittanceInfo.bankNo}}</b>） ,向以下收款账户转账<b>{{remittanceInfo.transferAmount}}</b>元。
                                        <b>打款时备注：该款项金额用于联合信任实名认证。</b> 实名认证的转账金额,将在转账完成后的次月前两周退回到您转账的账户中。
                                    </p>
                                </div>
                                <div class="table">
                                    <dl>
                                        <dt>户名</dt>
                                        <dd>{{remittanceInfo.tsaBankAccountName}}</dd>
                                    </dl>
                                    <dl>
                                        <dt>账号</dt>
                                        <dd>{{remittanceInfo.tsaBankNo}}</dd>
                                    </dl>
                                    <dl>
                                        <dt>开户银行</dt>
                                        <dd>{{remittanceInfo.tsaBankName}}</dd>
                                    </dl>
                                    <dl>
                                        <dt>行号</dt>
                                        <dd>{{remittanceInfo.bankCode}}</dd>
                                    </dl>
                                </div>
                                <div class="wait">
                                    <p style="color:#666">
                                        完成打款后,请耐心等待审核结果（审核时间以银行到账时间为准,一般1~3个工作日）,请在30日内完成打款
                                    </p>
                                </div>
                                <div class="submit">
                                    <span class="primary" @click="quit">退出认证</span>
                                    <span class="quit" @click="cancel">取消审核</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-row>
</template>
<script>
import {remittanceInfo,cancel} from '@http/user_center/realName'
import { identification } from "@http/user_center/userInfo";
export default {
    components: {},
    data() {
        return {
            remittanceInfo:{},
        };
    },
    async created() {
        let {authenticationStatus}=await identification();
        let status=authenticationStatus;
        if(status==6){
            let res=await remittanceInfo();
            this.remittanceInfo=res;
        }else{
            this.$router.replace({
                path:'/userCenter/AuthenticationName'
            })
        }
    },
    mounted() {},
    methods: {
       async cancel(){
            try {
                await cancel();
                this.$msg('已为您取消企业实名','success');
                this.remittanceInfo={};
                setTimeout(()=>{
                    this.$router.replace({
                        path: "/userCenter/AuthenticationName",
                    })
                },2000)
            } catch (error) {
                console.log(error)
                setTimeout(()=>{
                    this.$router.replace({
                        path: "/userCenter/AuthenticationName",
                    })
                },2000)
            }
            
        },
        quit(){
            if(this.$getlocalStorage("queryData")?.from=='lawcase'){
                window.location.href =`${process.env.VUE_APP_LAWCASE}/lawyer`
                return;
            }
            if(window.opener){
                window.opener = null;
                window.open('', '_self');
                window.close();
                setTimeout(()=>{
                    this.$router.replace({
                        path:'/Home'
                    })
                },3000)
            }else{
                this.$router.replace({
                    path:'/Home'
                })
            }
        }
    },
};
</script>
<style src="../../../assets/css/content.css" scoped></style>
<style scoped lang="less">
.mianContent{
    position: relative;
    .back{
        position:absolute;
        right: 30px;
        top:-30px;
        font-size: 14px;
        cursor: pointer;
        &:hover{
            color:#10A0E9
        }
    }
}
.main-box {
    width: 940px;
    margin: 0 auto;
}
.cnt {
    text-align: center;
}
.parpers_cnt {
    text-align: center;
    width: 100%;
    background: #fff;
    padding: 1px 31px;
    margin-top: 24px;
    box-sizing: border-box;
}
.ico-wrap {
    margin-bottom: 30px;
    img{
        width: 120px;
    }
}

.submit {
    margin-top: 32px;
    text-align: center;
}
.submit {
    span{
        display: inline-block;
        width: 130px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        color: #10A0E9;
        font-size: 16px;
        border-radius: 5px;
        border:1px solid #10A0E9;
        cursor: pointer;
    }
    .primary{
        background:#10A0E9;
        color: #fff;
        margin-bottom: 20px;
        margin-right: 50px;
        opacity: .7;
        &:hover{
            opacity: 1;
        }
    }
    .quit{
        color:#10A0E9;
        &:hover{
            background: #10a1e91d;
        }
    }
}

.bold {
    color: #333;
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 15px;
}
.thin {
    font-size: 14px;
    color: #999;
}
.table {
    width: 100%;
    margin-top: 29px;
    box-sizing: border-box;
    padding: 10px 20%;
    background: #fafafa;
    border: 1px solid #e1e6eb;
}
.table dl {
    overflow: hidden;
    border-bottom: 1px dashed #e1e6eb;
    padding: 20px 0 20px;
    font-size: 14px;
    color: #333;
}
.table dl:last-child {
    border: none;
}
.table dt {
    float: left;
}
.table dd {
    float: right;
}
.btns {
    width: 100px;
    padding-top: 14px;
}
.goback {
    display: inline-block;
    width: 94px;
    height: 28px;
    font-size: 14px;
    border-radius: 28px;
    cursor: pointer;
    line-height: 28px;
    background: #fff;
    color: #333;
    border: 1px solid #3080fe;
    margin-top: 12px;
}
.parpers_cnt p{
  margin: 1px 0 20px;
  font-size: 14px;
  color:#333;
}
.parpers_cnt .gz {
    font-size: 14px;
    line-height: 28px;
    font-weight: 500;
    color: #333;
    b{
        color: #F09135;
    }
}
.wait {
    color: #666;
    text-align: center;
    font-size: 15px;
    margin: 38px 0 40px;
}
.shz{
    display: block;
    font-weight: 600;
    font-size: 16px;
    margin-top: 20px !important;
}

.reasons{
  font-size: 14px;
  color:#666;
}
.goattestation span{
  margin-top: 20px;
  display: inline-block;
  width: 110px;
  height: 33px;
  line-height: 33px;
  border: 1px solid #3F7DF7;
  color:#3F7DF7;
  border-radius: 33px;
  cursor: pointer;
}
.goattestation span:hover{
  color:#fff;
  background:#3F7DF7;
}
.font-nowrap{
    white-space: nowrap;
}
.cancel{
    color:#3f7df7;
    cursor: pointer;
}
.cancel:hover{
    color:#79a9f8;
}
</style>
